// extracted by mini-css-extract-plugin
var _1 = "PdfView_card__5a198";
var _2 = "PdfView_counter__32444";
var _3 = "PdfView_dragIcon__d3005";
var _4 = "PdfView_iconWrapper__c45c0";
var _5 = "PdfView_label__df195";
var _6 = "PdfView_mask__6ff5b";
var _7 = "PdfView_navigation__4a8a9";
var _8 = "PdfView_textInner__2978f";
export { _1 as "card", _2 as "counter", _3 as "dragIcon", _4 as "iconWrapper", _5 as "label", _6 as "mask", _7 as "navigation", _8 as "textInner" }
